<template>
  <div class="grid">
    <div class="common-title" id="DATA-CENTER">
      <div class="common-title-content">
        数据中台
      </div>
      <div class="content">
        <img src="@/assets/images/coreCompetence/dataSys.png" alt="" />
        <div class="icon icon-jcsj"><div class="text">基础数据管理</div></div>
        <div class="icon icon-tjfx"><div class="text">统计分析</div></div>
        <div class="icon icon-ypmx"><div class="text">研判模型</div></div>
        <div class="icon icon-ywgl"><div class="text">社区业务管理</div></div>
        <div class="icon icon-kshfx"><div class="text">可视化分析</div></div>
        <div class="icon icon-spjgh"><div class="text">视频结构化</div></div>
        <div class="ico ico-rlsfzx"><div class="text">人脸算法中心</div></div>
        <div class="ico ico-qklfwzx">
          <div class="text">区块链服务中心</div>
        </div>
        <div class="ico ico-cjyysfzx">
          <div class="text">场景应用算法中心</div>
        </div>
        <div class="ico ico-spsfzx"><div class="text">视频算法中心</div></div>
        <div class="ico-text">数据中台</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dataCenter"
};
</script>

<style lang="less" scoped>
.grid {
  .content {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .icon {
      position: absolute;
      width: 2.4rem;
      height: 5.55rem;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      animation: scaleIcon 1s ease infinite alternate;
      .text {
        position: absolute;
        top: -1.35rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.8rem;
        color: #a0dbff;
        white-space: nowrap;
      }
      &.icon-jcsj {
        // top: 6.1rem;
        top: 6.41vw;
        left: 50%;
        transform: translateX(-50%);
        background-image: url("~@/assets/images/coreCompetence/icon-jcsj.png");
      }
      &.icon-tjfx {
        // top: 13.4rem;
        // left: 60rem;
        top: 14.08vw;
        left: 62.95vw;
        background-image: url("~@/assets/images/coreCompetence/icon-tjfx.png");
      }
      &.icon-ypmx {
        // top: 24.95rem;
        // left: 61.8rem;
        top: 26.27vw;
        left: 64.95vw;
        background-image: url("~@/assets/images/coreCompetence/icon-ypmx.png");
      }
      &.icon-ywgl {
        // top: 35.55rem;
        // left: 47.25rem;
        top: 37.36vw;
        left: 49.65vw;
        background-image: url("~@/assets/images/coreCompetence/icon-ywgl.png");
      }
      &.icon-kshfx {
        // top: 25.6rem;
        // left: 32.5rem;
        top: 26.9vw;
        left: 34.15vw;
        background-image: url("~@/assets/images/coreCompetence/icon-kshfx.png");
      }
      &.icon-spjgh {
        // top: 13.55rem;
        // left: 32.9rem;
        top: 14.24vw;
        left: 34.57vw;
        background-image: url("~@/assets/images/coreCompetence/icon-spjgh.png");
      }
    }
    .ico {
      position: absolute;
      width: 2.9rem;
      height: 2.9rem;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .text {
        position: absolute;
        top: -1.05rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.8rem;
        color: #ffffff;
        white-space: nowrap;
      }
      &.ico-rlsfzx {
        // top: 15.1rem;
        // left: 47.1rem;
        top: 15.86vw;
        left: 48.8vw;
        background-image: url("~@/assets/images/coreCompetence/ico-rlsfzx.png");
        // animation: translateIcon 10s ease infinite;
      }
      &.ico-qklfwzx {
        /* top: 21rem;
        left: 55.15rem; */
        top: 22.07vw;
        left: 57.96vw;
        background-image: url("~@/assets/images/coreCompetence/ico-qklfwzx.png");
      }
      &.ico-cjyysfzx {
        /* top: 25.55rem;
        left: 47.5rem; */
        top: 26.85vw;
        left: 48.92vw;
        background-image: url("~@/assets/images/coreCompetence/ico-cjyysfzx.png");
      }
      &.ico-spsfzx {
        /* top: 20.85rem;
        left: 38.95rem; */
        top: 21.91vw;
        left: 40.98vw;
        background-image: url("~@/assets/images/coreCompetence/ico-spsfzx.png");
      }
    }
    .ico-text {
      position: absolute;
      top: 21.3vw;
      left: 47.34vw;
      font-size: 1.4rem;
      font-family: "PangMenZhengDao", "PINGFANG", "PingFang SC",
        "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei";
      color: #ffffff;
    }
  }
}

@keyframes scaleIcon {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.07);
  }
}

@keyframes rotateIcon {
  0% {
    transform: translate(30px 30px);
  }
  12.5% {
    transform: rotate(45deg);
  }
  25% {
    transform: rotate(90deg);
  }
  37.5% {
    transform: rotate(135deg);
  }
  50% {
    transform: rotate(180deg);
  }
  62.5% {
    transform: rotate(225deg);
  }
  75% {
    transform: rotate(270deg);
  }
  87.5% {
    transform: rotate(315deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes translateIcon {
  0% {
    transform: translate(0, 0);
  }
  12.5% {
    transform: translate(5.15rem, 2.55rem);
  }
  25% {
    transform: translate(8.15rem, 5.15rem);
  }
  37.5% {
    transform: translate(5.15rem, 7.55rem);
  }
  50% {
    transform: translate(0, 9rem);
  }
  62.5% {
    transform: translate(-5.15rem, 7.55rem);
  }
  75% {
    transform: translate(-8.15rem, 5.15rem);
  }
  87.5% {
    transform: translate(-5.15rem, 2.55rem);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
